<template>
    
    <b-row>
        <b-col md="4" cols="12">
            <info-card label="أوجه الإنفاق المُراد توظيف الإعامة فيها"
            :value="data.expenditures"
            />
        </b-col>
        <b-col md="4" cols="12">
            <info-card
            label="الحساب المصرفي المُراد تحويل إليه"
            :value="data.ngo_bank_account_id ? data.ngo_bank_account_id.account_no : ''"
            />
        </b-col>      
    </b-row>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
  import InfoCard from "@/components/InfoCard.vue";
  export default {
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton
    },
    props: {
        data: Object ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
  };
  </script>